const BASE = 'https://api.pexels.com/v1';

const cache = new Map();

export async function getPexelsImage(query, index = 0) {
  const key = `${query}-${index}`;
  if (cache.has(key)) return cache.get(key);

  const apiKey = import.meta.env.VITE_PEXELS_API_KEY;
  if (!apiKey) return null;

  try {
    const res = await fetch(`${BASE}/search?query=${encodeURIComponent(query)}&per_page=5&orientation=landscape`, {
      headers: { Authorization: apiKey },
    });
    if (!res.ok) return null;
    const data = await res.json();
    const photo = data.photos?.[index] || data.photos?.[0];
    if (!photo) return null;
    const result = { url: photo.src.large2x, photographer: photo.photographer, photographerUrl: photo.photographer_url };
    cache.set(key, result);
    return result;
  } catch {
    return null;
  }
}

export async function getPexelsPortrait(query) {
  const apiKey = import.meta.env.VITE_PEXELS_API_KEY;
  if (!apiKey) return null;

  try {
    const res = await fetch(`${BASE}/search?query=${encodeURIComponent(query)}&per_page=3&orientation=portrait`, {
      headers: { Authorization: apiKey },
    });
    if (!res.ok) return null;
    const data = await res.json();
    const photo = data.photos?.[0];
    return photo ? { url: photo.src.large, photographer: photo.photographer } : null;
  } catch {
    return null;
  }
}
